import { render } from "./TheFeatures.vue?vue&type=template&id=76dcee96&scoped=true"
const script = {}

import "./TheFeatures.vue?vue&type=style&index=0&id=76dcee96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dcee96"]])

export default __exports__